import { render, staticRenderFns } from "./RemessasFaltando.vue?vue&type=template&id=ffda2b76"
import script from "./RemessasFaltando.vue?vue&type=script&lang=js"
export * from "./RemessasFaltando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports